import { Injectable } from '@angular/core';
import { environment } from '@/environments/environment';

/** 语音报报告 Dify 目标 */
export type DifyTarget = 'company' | 'local';

/**
 * 语音报报告 Dify 配置选择器。
 *
 * 通过运行时环境变量（无需重新构建）在"公司 Dify"与"本地 Dify"之间切换：
 *
 * 优先级：
 * 1. `window.__DIFY_TARGET__`（运行时全局注入，如浏览器控制台设置）
 * 2. `localStorage['tvms_dify_target']`（持久化切换，如设置 `localStorage.setItem('tvms_dify_target','local')`）
 * 3. 默认：company（公司 Dify，启用 TTS）
 *
 * 值：`company` | `local`
 */
@Injectable({ providedIn: 'root' })
export class DifyConfigService {
  private static readonly STORAGE_KEY = 'tvms_dify_target';

  /** 当前目标（运行时读取，不缓存，保证实时生效） */
  get target(): DifyTarget {
    // 1. 运行时全局
    try {
      const w = (window as any).__DIFY_TARGET__;
      if (w === 'company' || w === 'local') return w;
    } catch { /* 忽略 */ }
    // 2. localStorage 持久化
    try {
      const v = localStorage.getItem(DifyConfigService.STORAGE_KEY);
      if (v === 'company' || v === 'local') return v;
    } catch { /* 忽略 */ }
    // 3. 默认公司 Dify（本地 Dify 未启用 TTS）
    return 'company';
  }

  /** 切换目标（写入 localStorage，持久化） */
  setTarget(target: DifyTarget): void {
    try {
      localStorage.setItem(DifyConfigService.STORAGE_KEY, target);
    } catch { /* 忽略 */ }
  }

  /** 语音报报告当前生效的 apiUrl / apiKey */
  get voiceReportConfig(): { apiUrl: string; apiKey: string } {
    if (this.target === 'local') {
      return { apiUrl: environment.difyDeviationHelperLocalApiUrl, apiKey: environment.difyDeviationHelperLocalApiKey };
    }
    return { apiUrl: environment.difyDeviationHelperCompanyApiUrl, apiKey: environment.difyDeviationHelperCompanyApiKey };
  }
}
